const Submit = () => {
  return (
    <button
      type='submit'
      className='text-xl text-dark-color hover:text-light-color transition-all cursor-pointer bg-crimson px-3 py-2 mt-2 lg:mt-4 rounded text-center w-full m-auto'
    >
      <h1>Send</h1>
    </button>
  );
};

export default Submit;
